<mat-card style="border-radius: 0">
    <div *ngIf="subscriptionFound; else noSubscriptionFound" class="tw" style="overflow-y: auto">
        <table mat-table #subscriptionsTable [dataSource]="dataSourceSubscription" style="width: 100%" matSort>
            <ng-container matColumnDef="SubscriptionKey">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="titleTabContent" style="justify-content: flex-start">
                        <span translate>M_SUB_ASS_WITH</span>
                        <span>&nbsp;{{ copyOfSelectedAccount }}</span>
                    </div>
                    <div style="
                            display: flex;
                            justify-content: space-between;
                            width: 100%;
                            align-items: center;
                            padding-bottom: 1.2rem;
                            padding-top: 1.2rem;
                        ">
                        <div class="s" style="width: 35%">
                            <div style="display: flex; width: 100%">
                                <mat-icon matPrefix [inline]="true" class="m-r5" style="width: 5%"> search </mat-icon>
                                <input matInput [(ngModel)]="searchSubscription" (keyup)="applySubscriptionSearch($event)" placeholder="{{ 'M_SEARCH_SUB' | translate }}" />
                            </div>
                            <div>
                                <mat-icon matSuffix [inline]="true" class="cursor" (click)="clearSubscriptionSearch()"> close </mat-icon>
                            </div>
                        </div>
                        <div class="s" style="padding: 0 20px">
                            <div style="display: flex; align-items: center; width: 100%">
                                <div style="width: 100%">
                                    <mat-label translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </mat-label>
                                </div>
                                <div style="display: flex">
                                    <span class="material-icons"> filter_alt </span>
                                </div>
                                <mat-select style="width: 10%" (selectionChange)="doSomethingEvent($event)">
                                    <mat-option value="ALL"><span translate>M_LIST_ALL_SUB</span> </mat-option>
                                    <mat-option value="CO-USER-ADMIN"><span translate>ROLES_STRINGS.COUSERADMIN</span> </mat-option>
                                    <mat-option value="USER-ADMIN"><span translate>ROLES_STRINGS.USERADMIN </span> </mat-option>
                                    <mat-option value="POWER-USER"><span translate>ROLES_STRINGS.POWERUSER</span> </mat-option>
                                    <mat-option value="POWER-USER-SCHEDULER"><span translate>ROLES_STRINGS.POWERUSERSCHED </span>
                                    </mat-option>
                                    <mat-option value="POWER-USER-REPORT"><span translate>ROLES_STRINGS.POWERUSERREPORT </span>
                                    </mat-option>
                                    <mat-option value="SECURITY-ADMIN"> <span translate>ROLES_STRINGS.SECURITYADMIN</span></mat-option>
                                    <mat-option value="APPLICATION-ADMIN"><span translate> ROLES_STRINGS.APPLICADMIN</span> </mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                </th>

                <td mat-cell class="p-05-12" *matCellDef="let row" (click)="changeBackgroundSubscriptionEvent(row.SubscriptionKey)">
                    <div style="display: flex; width: 100%">
                        <div style="display: flex; flex-direction: column; width: 30%; justify-content: flex-start">
                            <span class="tableRowContent1">
                                {{ row.Description }}
                            </span>
                            <span class="tableRowContent2">
                                {{ row.SubscriptionKey }}
                            </span>
                        </div>
                        <div style="display: flex; width: 40%; justify-content: flex-start; flex-wrap: wrap !important">
                            <div class="rolesLogin" *ngFor="let roles of row.Roles">
                                <span>
                                    {{ roles }}
                                </span>
                            </div>
                        </div>
                        <div style="display: flex; width: 30%; justify-content: flex-end">
                            <span matTooltip="{{ 'EDIT_SUBSCRIPTION.DATE' | translate }}" matTooltipClass="tooltip-layout">
                                {{ row.CreationDate | date: 'dd/MM/yyyy' }}
                            </span>
                        </div>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnSubscription"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnSubscription" class="pointer" [ngClass]="row.IsClicked ? 'bgBluLight' : ''" (click)="openDrawerEvent(row)"></tr>
        </table>
        <mat-paginator #paginatorSubs [pageSizeOptions]="[3]" [pageSizeOptions]="[5, 10, 25, 100]" style="position: sticky; bottom: 0">
        </mat-paginator>
    </div>
    <ng-template #noSubscriptionFound>
        <div class="tw">
            <table class="mat-table" style="width: 100%; height: 100%">
                <tr class="mat-header-row">
                    <th class="mat-header-cell">
                        <div class="titleTabContent" style="justify-content: flex-start">
                            <span translate>M_SUB_ASS_WITH <span> {{ copyOfSelectedAccount }}</span></span>
                        </div>
                        <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; padding-bottom: 1.2rem">
                            <div class="s" style="width: 35%">
                                <div style="display: flex; width: 100%">
                                    <mat-icon matPrefix [inline]="true" class="m-r5" style="width: 5%"> search </mat-icon>
                                    <input matInput [(ngModel)]="searchSubscription" (keyup)="applySubscriptionSearch($event)" placeholder="{{ 'M_SEARCH_SUB' | translate }}" />
                                </div>
                                <div>
                                    <mat-icon matSuffix [inline]="true" class="cursor" (click)="clearSubscriptionSearch()">
                                        close
                                    </mat-icon>
                                </div>
                            </div>
                            <div class="s" style="padding: 0 20px" *ngIf="showFilterOptionsSubscription">
                                <div style="display: flex; width: 100%; align-items: center; width: 100%">
                                    <div style="width: 100%">
                                        <mat-label translate>SUBSCRIPTIONS_ACCOUNTS.FILTER_BY </mat-label>
                                    </div>
                                    <div style="display: flex">
                                        <span class="material-icons"> filter_alt </span>
                                    </div>
                                    <mat-select style="width: 10%" (selectionChange)="doSomethingEvent($event)">
                                        <mat-option value="ALL"><span translate>M_LIST_ALL_SUB</span> </mat-option>
                                        <mat-option value="CO-USER-ADMIN"><span translate>ROLES_STRINGS.COUSERADMIN</span> </mat-option>
                                        <mat-option value="USER-ADMIN"><span translate>ROLES_STRINGS.USERADMIN</span> </mat-option>
                                        <mat-option value="POWER-USER"><span translate>ROLES_STRINGS.POWERUSER</span> </mat-option>
                                        <mat-option value="POWER-USER-SCHEDULER"><span translate>ROLES_STRINGS.POWERUSERSCHED</span>
                                        </mat-option>
                                        <mat-option value="POWER-USER-REPORT"><span translate>ROLES_STRINGS.POWERUSERREPORT</span>
                                        </mat-option>
                                        <mat-option value="SECURITY-ADMIN"><span translate>ROLES_STRINGS.SECURITYADMIN</span> </mat-option>
                                        <mat-option value="APPLICATION-ADMIN"><span translate> ROLES_STRINGS.APPLICADMIN</span>
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                    </th>
                </tr>
                <tr class="mat-row">
                    <td class="mat-cell p-05-12">
                        <span translate>M_SUB_NOT_FOUND</span>
                    </td>
                </tr>
            </table>
        </div>
    </ng-template>
</mat-card>